import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TranslationService {
  url: String = environment.url;
  translations: Array<any> = [];
  languages: Array<any> = [];
  constructor(private http: HttpClient) { }

  setLanguages(data){
    this.languages = data;
  }

  getLanguages() {
    return this.http.post(this.url + '/api/translations/lang', { page: 0, limit: 0 });
  }

  getTranslations(lang) {
    return this.http.post(this.url + `/api/translations/trans/${lang}/0/0`, { search: '' }).subscribe((res: any) => {
      this.translations = res.data;
    });
  }

  translate(key) {
    let obj = this.translations.find((trans: any) => key == trans.key);
    if (obj)
      return obj.value;
  }

}
